"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { card, colors, heroBackground, pageContainer, radius, shadow } from "@/styles/theme";

type PublicJourney = {
  id: string;
  name: string;
  description: string;
  startDate: string | null;
  endDate: string | null;
  ownerId: string;
  ownerUsername: string;
};

export default function PublicJourneysPage() {
  const [journeys, setJourneys] =
    useState<PublicJourney[]>([]);

  const [loaded, setLoaded] =
    useState(false);

  useEffect(() => {
    fetch("/api/public/journeys")
      .then((res) => res.json())
      .then((data) => {
        setJourneys(data);
        setLoaded(true);
      });
  }, []);

  return (
    <div style={heroBackground}>
    <main style={{ ...pageContainer, maxWidth: "800px", margin: "0 auto", padding: "50px 20px" }}>
      <h1
        style={{
          fontSize: "28px",
          fontWeight: 800,
          backgroundImage: colors.gradient,
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          color: "transparent",
        }}
      >
        Public Journeys
      </h1>

      <p style={{ marginTop: "12px" }}>
        <Link
          href="/"
          style={{
            color: colors.accentStart,
            background: colors.cardBg,
            padding: "6px 14px",
            borderRadius: radius.pill,
            boxShadow: shadow.card,
          }}
        >
          &larr; Back to login
        </Link>
      </p>

      {!loaded && (
        <p style={{ ...card, color: colors.textSecondary, marginTop: "20px" }}>
          Loading...
        </p>
      )}

      {loaded && journeys.length === 0 && (
        <p style={{ ...card, color: colors.textSecondary, marginTop: "20px" }}>
          No public journeys yet.
        </p>
      )}

      <div
        style={{
          display: "grid",
          gap: "15px",
          marginTop: "20px",
        }}
      >
        {journeys.map((journey) => (
          <Link
            key={journey.id}
            href={`/public/${journey.id}`}
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{ ...card, transition: "box-shadow 0.15s ease, transform 0.15s ease" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = shadow.cardHover;
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = shadow.card;
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <h3>{journey.name}</h3>
              <p style={{ color: colors.textSecondary, marginTop: "4px" }}>
                {journey.description}
              </p>
              <p
                style={{
                  fontSize: "13px",
                  color: "#fff",
                  backgroundImage: colors.gradient,
                  display: "inline-block",
                  padding: "3px 10px",
                  borderRadius: radius.pill,
                  marginTop: "10px",
                }}
              >
                by {journey.ownerUsername}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </main>
    </div>
  );
}
